import { render } from "./PatientPreadmissionNotesRow.vue?vue&type=template&id=0b1503fd&ts=true"
import script from "./PatientPreadmissionNotesRow.ts?vue&type=script&lang=ts&external"
export * from "./PatientPreadmissionNotesRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__